import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, finalize, Observable, take } from 'rxjs';
import {
  GroupSummaryReport,
  GroupSummaryReportRequest,
  LocationSummaryReport,
  LocationSummaryReportRequest,
} from 'src/app/core/models/reports/reports.model';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { environment } from 'src/environments/environment';
import { ErrorhandleService } from '../../error-handling/error-handle/errorhandle.service';

@Injectable({
  providedIn: 'root',
})
export class SummaryReportsService {
  baseUrl = environment.apiUrl.concat('report-management/');

  constructor(
    private http: HttpClient,
    private commonUtils: CommonUtils,
    private errorHandler: ErrorhandleService,
  ) {}

  /**
   * Get Location Summary Report for given location and date
   *
   * @param {LocationSummaryReportRequest} request
   * @return {*}  {Observable<LocationSummaryReport>}
   * @memberof SummaryReportsService
   */
  getLocationSummaryReport(
    request: LocationSummaryReportRequest,
  ): Observable<LocationSummaryReport> {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .get<LocationSummaryReport>(
        this.baseUrl.concat('location-summary-report'),
        {
          params: { ...request },
        },
      )
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<LocationSummaryReport>(
            error,
            error.status,
            'Summary Report Service: Get Location summary Report',
          ),
        ),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }

  /**
   * Get Group Summary Report for given location and date
   *
   * @param {GroupSummaryReportRequest} request
   * @return {*}  {Observable<GroupSummaryReport>}
   * @memberof SummaryReportsService
   */
  getGroupSummaryReport(
    request: GroupSummaryReportRequest,
  ): Observable<GroupSummaryReport> {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .get<GroupSummaryReport>(this.baseUrl.concat('group-summary-report'), {
        params: { ...request },
      })
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<GroupSummaryReport>(
            error,
            error.status,
            'Summary Report Service: Get Group summary Report',
          ),
        ),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }
}
